export const RESET = '@@@common.act.RESET';
export const UPDATE_FORM = '@@@common.act.UPDATE_FORM';
export const RESET_FORM = '@@@common.act.RESET_FORM';
export const RESET_HASH_FORM = '@@@common.act.RESET_HASH_FORM';
export const VALIDATION_RESET = '@@@common.act.VALIDATION_RESET';
export const REDIRECT = '@@@common.act.REDIRECT';
export const GRID_RELOAD = '@@@common.act.GRID_RELOAD';
export const FORM_GRID_RESET = '@common.form.FORM_GRID_RESET';
export const GRID_RESET = '@@@common.act.GRID_RESET';
export const GRID_SELECTEDITENS_SET = '@@@common.act.SELECTEDITENS_SET';
export const SET_INITIAL_VALUES_ONEDIT = '@@@common.act.SET_INITIAL_VALUES_ONEDIT';
export const CLEAR_INPUTS_GRID = '@common.act.CLEAR_INPUTS_GRID';
export const TREEVIEW_RELOAD = '@common.act.TREEVIEW_RELOAD';
export const SET_FIELD_VALUE = '@common.act.SET_FIELD_VALUE';
export const ON_OPEN_FILTER = '@@@common.act.ON_OPEN_FILTER';
export const CLOSE_MENU = '@@@common.act.CLOSE_MENU';
export const CLEAN_FILTER_GRID = '@common.act.CLEAN_FILTER_GRID';
